import _get from 'lodash/get';
import { LOCK } from '@bedrock-rdk/constants';

/**
 * Creates Lightning template patch for applying of a text string to a content template label
 * @see https://rdkcentral.github.io/Lightning/docs/textures/text
 *
 * @param {string} text string to display
 * @param {number} wordWrapWidth maximal text width after which there will be a line break
 * @param {number} color text color to apply
 */
export const makeTextPatch = (text, wordWrapWidth, color) => ({
  visible: Boolean(text),
  color,
  text: {
    text,
    wordWrapWidth,
  },
});

const isLocked = item => _get(item, 'action.target.type') === LOCK;

// NOTE: the lock is part of the comparison because it drops as soon as the user gets access to the
// content (i.e. after a subscription upgrade) while the item id stays the same
export const areContentItemsEqual = (first, second) =>
  first && second ? first.id === second.id && isLocked(first) === isLocked(second) : false;
/**
 * Shared stand-in for a size or image option entry a template does not define. Read only: it is handed to every
 * caller that misses, so nothing may write to it.
 */
const EMPTY_TEMPLATE_ENTRY = {};

/**
 * Reads a `[template][renderingContext][screenSize]` entry out of one of the static size or image option maps a
 * content template declares.
 *
 * @param {Object} source a `{ [template]: { [context]: { [screenSize]: entry } } }` map
 * @param {string} template content template identifier
 * @param {string} renderingContext one of RENDERING_CONTEXT values
 * @param {string} screenSize one of the screen size constants
 * @returns {Object} the entry, or a shared empty object when the map does not define one
 */
export const getTemplateEntry = (source, template, renderingContext, screenSize) => {
  const contexts = source && source[template];
  const screenSizes = contexts && contexts[renderingContext];

  return (screenSizes && screenSizes[screenSize]) || EMPTY_TEMPLATE_ENTRY;
};

export const areContextsEqual = (first, second) => first === second;

// NOTE: The same CW order is used in CSS paddings/margins
export const ICON_POSITION = {
  TOP_LEFT: 0,
  TOP_RIGHT: 1,
  BOTTOM_RIGHT: 3,
  BOTTOM_LEFT: 4,
  CENTER: 5,
};
